import React from "react";
import ChangePassword from "@components/Auth/ChangePassword/ChangePassword";
import { getAbsoluteImagePath } from "@utils/dom";
import { useConfig, useSession } from "@hooks";
import { getLocalStorageItem } from "@utils/localStorage";
import { useSearchParams } from "react-router-dom";
import { getCustomerUrlByWebUser } from "@utils/tools";
import { ForgetPassword2 } from "@components/Auth/ForgetPassword/ForgetPassword";

type ChangePasswordWidgetProps = {};

export const ChangePasswordWidget: React.FC<ChangePasswordWidgetProps> = () => {
  const { getLanguageVarValue } = useSession();
  const { mode: clientMode, logo } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";

  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const getWebUser = () => {
    const localWebuser = getLocalStorageItem("webuser");
    return (
      searchParams.get("webuser") ??
      searchParams.get("wu") ??
      localWebuser ??
      process.env.REACT_APP_WEBUSER!!
    );
  };

  return (
    <div className="tw-container tw-mx-auto">
      <div
        className={`${
          mode === "vacanceole"
            ? "tw-bg-primary-500"
            : "tw-bg_corseole-secondary"
        } tw-flex tw-justify-between tw-py-2 tw-px-2 tw-text-white tw-mb-1`}
      >
        <a href={getCustomerUrlByWebUser(getWebUser(), mode)}>
          <img
            className="tw-w-20 md:tw-w-36"
            src={getAbsoluteImagePath(
              `/assets/img/customer/${
                mode === "vacanceole" ? "Vacanceole-B-RVB.png" : logo
              }`
            )}
          ></img>
        </a>
      </div>
      <h1 className="tw-mt-4 tw-text-3xl tw-font-medium tw-text-center tw-font-dosis tw-mb-6">
        {getLanguageVarValue(
          token
            ? "LANG_neobooking_change_password"
            : "LANG_neobooking_forgot_password"
        )}
      </h1>
      {token ? (
        <div>
          <ChangePassword token={token} />
        </div>
      ) : (
        <div>
          <ForgetPassword2 defaultEmail="" />
        </div>
      )}
    </div>
  );
};

export default ChangePasswordWidget;
